import { render } from "./StatuspagegroupsIcon.vue?vue&type=template&id=19a25f50&scoped=true"
import script from "./StatuspagegroupsIcon.vue?vue&type=script&lang=js"
export * from "./StatuspagegroupsIcon.vue?vue&type=script&lang=js"

import "./StatuspagegroupsIcon.vue?vue&type=style&index=0&id=19a25f50&scoped=true&lang=css"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19a25f50"]])

export default __exports__